import { useState, useEffect } from 'react';
import {
  Button, TextField, Link, Grid2 as Grid, Typography, InputAdornment, IconButton
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { isEmpty } from '../common/helpers';

const LoginForm = ({ login, errors }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  useEffect(() => {
    const email = errors?.find(info => info.path === 'email' || info.param === 'email');
    const password = errors?.find(info => info.path === 'password' || info.param === 'password');
    
    if(!isEmpty(email) || !isEmpty(password)){
      setError({
        email: email?.msg,
        password: password?.msg
      });
    }
    if(errors?.find(info => info.msg === 'Inválido')){
      setError({
        password: 'Inválido'
      });
    }
  }, [errors]);

  const irA = where => e => {
    e.preventDefault();
    navigate(where);
  }

  const cambiar = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const log = async e => {
    e.preventDefault();
    await login(data.email, data.password);
  }

  return (
    <Grid className="form" size={{ md:6 }} mb={{ xs: 3, md: 0 }}>
      <form onSubmit={log} noValidate>
        <Grid container sx={{my: 2}}>
          <Grid size={12} sx={{ textAlign: "center" }}>
            <Typography variant="h3" component="h3">Ingresa ahora</Typography>
          </Grid>
          <Grid size={12}>
            <TextField
              className="input-login"
              error={isEmpty(error.email) ? false : true}
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              value={data.email}
              onChange={cambiar}
              helperText={!isEmpty(error.email) && error.email}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              className="input-login"
              error={isEmpty(error.password) ? false : true}
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              id="password"
              autoComplete="current-password"
              value={data.password}
              onChange={cambiar}
              helperText={!isEmpty(error.password) && error.password}
            />
          </Grid>
          <Grid 
            item 
            container
            direction="row"
            size={12}
            sx={{
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <Typography className="btn-actions" variant="caption">
              <Link component="button" onClick={irA("/forgot-pass")} type='button'>
                Olvidé mi contraseña
              </Link>
            </Typography>
            <Typography className="btn-actions" variant="caption">
              <Link component="button" onClick={irA("/saber-mas")} type='button'>
                Saber más
              </Link>
            </Typography>
          </Grid>
        </Grid>
        <Button
          sx={{mb: 1}}
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
        >
          Entrar
        </Button>
        <Grid>
          <Grid container direction="row" alignItems="center" justifyContent="center">
            <Button
              type="button"
              variant="contained"
              color="secondary"
              className="signup"
              onClick={irA("/signup")}
              disableElevation
              fullWidth
            >
              Crear cuenta
            </Button>
          </Grid>          
        </Grid>
      </form>
    </Grid>
  );
}

LoginForm.protoTypes = {
  login: PropTypes.func.isRequired,
  errors: PropTypes.array
}

export default LoginForm;